// extracted by mini-css-extract-plugin
export default {"footer":"UaUmFZst","logo":"xLip99iY","about":"UH_mQIi8"};